module.exports = __webpack_public_path__ + "img/goldBean.9fe91287.png";